import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { LanguageService } from "../../services/language.service";
import { LocalStorageService } from "../../services/local-storage.service";

@Component({
  selector: 'app-project-portal-employee-selector',
  templateUrl: './project-portal-employee-selector.component.html',
  styleUrls: ['./project-portal-employee-selector.component.css']
})
export class ProjectPortalEmployeeSelectorComponent implements OnInit {
  readonly supervisorEmployeeKey = 'direct-desktop-project-portal-approval-supervisor-employee';

  @Output() employeeValueChanged = new EventEmitter<number>();

  employees: any[] = [];
  selectedEmployee: any = null;

  constructor(public languageService: LanguageService, private localStorageService: LocalStorageService) {}

  async ngOnInit() {
  }

  onEmployeeValueChanged(e: any) {
    this.localStorageService.set(this.supervisorEmployeeKey, e.value);
    this.employeeValueChanged.emit(e.value);
  }

}
